import { AnyAction } from 'redux';
import produce, { Draft } from 'immer';
import { V3FeatureFlagTask } from '../../types';
import { ACTION_NAMES } from '../../constants';

type V3FeatureFlagSliceInRedux = {
  featureFlags: Record<string, boolean>;
};

type V3FeatureFlagAction = {
  result: V3FeatureFlagTask;
};

const initialState = { featureFlags: {} } as V3FeatureFlagSliceInRedux;

export const v3FeatureFlagReducer = (
  state = initialState,
  action: AnyAction & V3FeatureFlagAction
): V3FeatureFlagSliceInRedux =>
  produce(state, (draft: Draft<V3FeatureFlagSliceInRedux>) => {
    switch (action.type) {
      case `${ACTION_NAMES.V3_LOAD_FEATURE_FLAGS}_SUCCESS`:
        Object.assign(draft.featureFlags, action.result.resourceAfterWrite.output.featureFlags ?? {});
        break;
      default:
      // nothing to do => immer returns the original object
    }
  });
